module.exports = __webpack_public_path__ + "media/images/fm_12-61d51dab121ea96d86f0867b6eaaac7e.png";